import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Grid, Typography } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { useStyles } from '~/modules/projects/project/BillPlan/BillPlanPreRequisites/hooks';
import { useHasPermission } from '~/modules/common/permissions';
import AddDynamicRateCard from './AddDynamicRateCard';
import AddMilestoneTaskLink from './AddMilestoneTaskLink';

const formatMessage = (classes, id) => {
  return (
    <Typography className={classes.alert} component="div">
      <FormattedMessage className={classes.textControl} id={id} />
    </Typography>
  );
};

export const BillPlanError = ({
  projectDetails,
  title,
  milestoneTaskAvailable,
  rateAvailable,
  setMilestoneTaskCreated,
  setTaskAddedCount,
  setRatesModifier,
  ratesCount,
  hasViewRatePermission,
  hasViewEditRatePermission
}) => {
  const classes = useStyles();

  const canEditTasks = useHasPermission({
    actionUri: 'urn:replicon:project-action:edit-tasks'
  });

  return (
    <>
      {rateAvailable && !ratesCount && (
        <>
          <Grid container spacing={0} data-qe-id="RateCardRequired">
            <div className={classes.root}>
              <Alert
                severity="error"
                className={classes.alert}
                data-qe-id="ErrorMessage"
              >
                <strong>{title}</strong>
                {hasViewEditRatePermission && hasViewRatePermission && (
                  <AddDynamicRateCard
                    projectDetails={projectDetails}
                    setRatesModifier={setRatesModifier}
                  />
                )}
                {!hasViewEditRatePermission &&
                  formatMessage(
                    { classes },
                    'billPlanPreRequisites.noViewEditRateCardPermission'
                  )}
                {!hasViewRatePermission && [
                  formatMessage(
                    { classes },
                    'billPlanPreRequisites.billingRateRequiredMessage'
                  ),
                  formatMessage(
                    { classes },
                    'billPlanPreRequisites.noEditRatePermission'
                  )
                ]}
              </Alert>
            </div>
          </Grid>
        </>
      )}
      {milestoneTaskAvailable && (
        <Grid container spacing={0}>
          <div className={classes.root}>
            <Alert severity="error" className={classes.alert}>
              <strong>{title}</strong>
              {canEditTasks && (
                <AddMilestoneTaskLink
                  projectDetails={projectDetails}
                  setMilestoneTaskCreated={setMilestoneTaskCreated}
                  setTaskAddedCount={setTaskAddedCount}
                />
              )}
            </Alert>
          </div>
        </Grid>
      )}
    </>
  );
};

BillPlanError.propTypes = {
  projectDetails: PropTypes.object,
  title: PropTypes.string,
  milestoneTaskAvailable: PropTypes.bool,
  rateAvailable: PropTypes.bool,
  setMilestoneTaskCreated: PropTypes.func,
  setTaskAddedCount: PropTypes.func,
  setRatesModifier: PropTypes.func,
  ratesCount: PropTypes.number,
  hasViewEditRatePermission: PropTypes.bool,
  hasViewRatePermission: PropTypes.bool
};

export default BillPlanError;
